import { createContext } from "@wordpress/element";

let PatternContext = createContext();

export default PatternContext;